export { default } from './HoldStatusIcon';



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldStatusIcon/index.js